import { normalizeParentQuantity } from "../../../normalizers/normalizeParentQuantity";
import { normalizeQuantity } from "../../../normalizers/normalizeQuantity";


export function handleAdminParentQDUpdated(state, payload) {
    const snapshot = payload;

    const parentNodeId = `p${snapshot.id}`;

    const existingParent =
        state.quantitiesById[parentNodeId];

    if (!existingParent) {
        return state;
    }

    const quantitiesById = {
        ...state.quantitiesById,
    };

    const parentNode = {
        ...normalizeParentQuantity(snapshot),
        type: "parent",
        canEditPrice: true,
        quantityDefinitions: [],
    };

    for (const q of snapshot.quantity_definitions) {
        const qNode = {
            ...normalizeQuantity(q),
            type: "quantity",
            canEditPrice: false,
            nodeId: `q${q.id}`,
        };

        quantitiesById[`q${q.id}`] = qNode;

        parentNode.quantityDefinitions.push(qNode);
    }

    quantitiesById[parentNodeId] = parentNode;

    console.log('quantitiesById[parentNodeId]: for parent updated  ', quantitiesById[parentNodeId])
    return {
        ...state,
        quantitiesById,
    };
}